/* ------------------------------------------------------------------
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
function lazyLoadCDN(src = "", type = "text/javascript") {
  const loadCDN = function () {
    const ad = document.createElement("script");
    ad.type = type;
    ad.async = true;
    ad.src = src;
    ad.setAttribute("crossorigin", "anonymous");
    const sc = document.getElementsByTagName("script")[0];
    sc.parentNode.insertBefore(ad, sc);
  };

  lazyLoadFunction(loadCDN);
}

function lazyLoadFunction(callBack) {
  let lazyLoad = false;
  function onLazyLoad() {
    if (lazyLoad === false) {
      lazyLoad = true;
      window.removeEventListener("scroll", onLazyLoad);
      window.removeEventListener("mousemove", onLazyLoad);
      window.removeEventListener("mousedown", onLazyLoad);
      window.removeEventListener("touchstart", onLazyLoad);

      callBack();
    }
  }
  window.addEventListener("scroll", onLazyLoad);
  window.addEventListener("mousemove", onLazyLoad);
  window.addEventListener("mousedown", onLazyLoad);
  window.addEventListener("touchstart", onLazyLoad);
  window.addEventListener("load", () => {
    if (window.pageYOffset) onLazyLoad();
  });
}

// NOTE: adsenseのLazyLoad
function lazyLoadAdsense() {
  $(document).ready(() => {
    lazyLoadCDN(
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8108546734202702"
    );
  });
}

// NOTE: React ESM バンドルおよびエントリポイントからのグローバル参照に対応するため window に公開
// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export { lazyLoadAdsense, lazyLoadCDN, lazyLoadFunction };
